<div class="detail-container">
  <!-- Header -->
  <div class="detail-header">
    <div class="header-content">
      <div class="header-left">
        <i class="fa-solid fa-map-location-dot"></i>
        <div class="header-text">
          <h1>Roadmap</h1>
          <p class="header-subtitle">{{ view === 'projects' ? 'Iniciativas grandes · lo que está por hacerse, con sus entregables' : view === 'metrics' ? 'Desempeño de TI · velocidad, puntos por frente y calidad' : 'Backlog y tablero del sprint · tareas y bugs del equipo interno' }}</p>
        </div>
      </div>
      <!-- Toggle de vista: centrado en la fila del título, estable (no depende del subtítulo) -->
      <div class="view-toggle">
        <button type="button" [class.active]="view === 'work'" (click)="view = 'work'">
          <i class="fa-solid fa-diagram-project"></i> Mapa de trabajo
        </button>
        <button type="button" *ngIf="isAdmin" [class.active]="view === 'metrics'" (click)="view = 'metrics'">
          <i class="fa-solid fa-gauge-high"></i> Métricas
        </button>
        <button type="button" *ngIf="isAdmin" [class.active]="view === 'projects'" (click)="view = 'projects'">
          <i class="fa-solid fa-diagram-next"></i> Proyectos
        </button>
      </div>
      <div class="header-right" *ngIf="view === 'projects'">
        <span class="meta-chip"><i class="fa-solid fa-diagram-next"></i> {{ projects.length }} proyectos</span>
        <span class="meta-chip"><i class="fa-solid fa-bolt"></i> {{ startedCount }} arrancados</span>
        <button type="button" class="meta-btn" (click)="openCreate()">
          <i class="fa-solid fa-plus"></i> Nuevo
        </button>
      </div>
    </div>
  </div>

  <!-- Mapa de trabajo: Backlog (Lista) + Tablero (Kanban) respaldados por DB (módulo worklog) -->
  <div class="info-card map-card" *ngIf="view === 'work'">
    <div class="card-content">
      <app-worklog-container></app-worklog-container>
    </div>
  </div>

  <!-- Tablero de métricas (desempeño de TI) — solo Admin. Se alimenta solo desde el backend. -->
  <div class="metrics-view" *ngIf="view === 'metrics' && isAdmin">
    <app-roadmap-board></app-roadmap-board>
  </div>

  <!-- Proyectos: lo que aún no arranca — solo Admin.
       La línea de tiempo se mudó a Mapa de trabajo → Tiempos, donde su duración significa algo, y
       las épicas conseguidas viven ahí. Aquí queda lo que está por hacerse (ADR-0048 · D1). -->
  <ng-container *ngIf="view === 'projects' && isAdmin">
    <div class="info-card map-card">
      <div class="card-header">
        <i class="fa-solid fa-diagram-next text-purple-600"></i>
        <h3>Proyectos de la plataforma</h3>
      </div>
      <div class="card-content map-content">
        <app-roadmap-projects [projects]="projects" [canSeePrice]="isAdmin" [loading]="loadingProjects"
          (select)="onSelectProject($event)" (create)="openCreate()"></app-roadmap-projects>
      </div>
    </div>
  </ng-container>
</div>

<!-- Detalle de la épica -->
<p-dialog [(visible)]="dialogVisible" [modal]="true" [closable]="true" [dismissableMask]="true"
  [style]="dialogStyle" [breakpoints]="dialogBreakpoints" header="Detalle de la épica">
  <app-roadmap-epic-card *ngIf="selectedEpic" [row]="selectedEpic"></app-roadmap-epic-card>
</p-dialog>

<!-- Detalle del proyecto: se lee y se edita en el mismo sitio -->
<p-dialog [(visible)]="projectDialogVisible" [modal]="true" [closable]="true" [dismissableMask]="true"
  [style]="dialogStyle" [breakpoints]="dialogBreakpoints" header="Proyecto">
  <app-roadmap-project-detail *ngIf="selectedProject" [row]="selectedProject" [canEditPrice]="isAdmin"
    [saving]="saving" [error]="errorMsg"
    (save)="saveProject($event)" (remove)="removeProject()"></app-roadmap-project-detail>
</p-dialog>

<!-- Alta ligera: nombre y categoría. Lo demás se llena después, en sesión de requerimientos —
     pedir todo de entrada convierte el registro en un formulario que nadie llena. -->
<p-dialog [(visible)]="createVisible" [modal]="true" [closable]="true" [dismissableMask]="true"
  [style]="dialogStyle" [breakpoints]="dialogBreakpoints" header="Registrar un proyecto">
  <div class="np">
    <p class="np-hint">Con el nombre basta. Los requerimientos, entregables y precio se agregan después.</p>
    <div class="np-err" *ngIf="errorMsg"><i class="fa-solid fa-triangle-exclamation"></i> {{ errorMsg }}</div>
    <label class="np-field">Nombre
      <input class="np-input" [(ngModel)]="nuevoNombre" placeholder="Módulo de Contabilidad"
        (keydown.enter)="createProject()" />
    </label>
    <label class="np-field">Categoría
      <p-dropdown [options]="CATEGORIES" [(ngModel)]="nuevaCategoria" optionLabel="name" optionValue="id"
        appendTo="body" styleClass="w-full"></p-dropdown>
    </label>
    <div class="np-actions">
      <button type="button" class="np-btn" (click)="createVisible = false" [disabled]="saving">Cancelar</button>
      <button type="button" class="np-btn primary" (click)="createProject()" [disabled]="saving || !nuevoNombre.trim()">
        <i class="fa-solid" [ngClass]="saving ? 'fa-spinner fa-spin' : 'fa-plus'"></i> Registrar
      </button>
    </div>
  </div>
</p-dialog>
